import { Modal, Button, Placeholder } from "rsuite";
import "./updateRole.scss";
import { useState, useMemo, useEffect } from "react";
import {
  Checkbox,
  CheckboxGroup,
  RadioGroup,
  Radio,
  SelectPicker,
  CheckPicker,
} from "rsuite";
import { Roles, Levels } from "./../../routes/Paths";
import { privileges } from "../../logic/utils/privileges";

export default function UpdateRole(props) {
  const [activeRole, setActiveRole] = useState();
  const [activeAdditionalRole, setActiveAdditionalRole] = useState();
  const [activeLevel, setLevel] = useState();
  const [locations, setLocations] = useState([]);
  const [loader, setLoader] = useState(true);
  const [activeState, setState] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [activeDist, setDist] = useState([]);
  const [distData, setDistData] = useState([]);
  const [activeVillage, setVillage] = useState([]);
  const [villageData, setVillageData] = useState([]);
  const [additionalRoleData, setAdditionalRoleData] = useState(Roles);
  const [showLevels, setShowLevels] = useState(false);
  const excludedIds = [0, 3, 4, 5, 6, 99];
  const roleData = Roles.filter((role) => !excludedIds.includes(role.id)).map(
    (item) => ({ label: item.role, value: item.id })
  );


  const handleClose = () => props.modalClose();

  const handleConfirm = () => {
    let userData = {
      additionalRole: [...activeAdditionalRole, (activeLevel && showLevels ) && activeLevel+2].filter(Boolean),
      role: activeRole,
      state: activeState,
      district: activeDist,
      block: activeVillage,
      levelId: activeLevel,
      privileges:
        activeAdditionalRole.length != 0
          ? privileges([...activeAdditionalRole, activeRole,(activeLevel && showLevels ) && activeLevel+2].filter(Boolean))
          : privileges([activeRole]),
    };
    props.updateRole(userData);
  };

  const handleChangeRoles = (role) => {
    setActiveRole(role);
    setAdditionalRoleData(Roles.filter((item) => item.id !== role));
  };

  const handleChangeAdditionalRoles = (role) => {
    setActiveAdditionalRole(role);
    console.log("role", role);
  };
  const handleChangeLevel = (level) => {
    setLevel(level);
  };

  // Add default value on page load
  useEffect(() => {
    getLocation();
    setLevel(props.user.level_id);
    setActiveRole(props.user.role_id);
    setActiveAdditionalRole(props.user.other_roles);
    setState(props.user.r_state);
    setDist(props.user.r_district);
    setVillage(props.user.r_block);
    setShowLevels(props.user.level_id ? true : false);

    if (props.user.r_block && props.user.r_block.length !== 0) {
      handleStateChange(props.user.r_state);
      handleDistChange(props.user.r_district);
      handleVillageChange(props.user.r_block);
    }

  }, [props,activeState]);
  console.log("stateData ---", stateData);

  async function getLocation() {
    try {
      const response = await fetch(
        "https://tnp-utils.s3.ap-south-1.amazonaws.com/location.json"
      );
      const locations = await response.json();
      let locData = [];
      let statesArray = [];
      let temp = [];
      locations.forEach((location) => {
        Object.keys(location).forEach((state, i) => {
          statesArray.push(state);
          location[state].forEach((distObj, j) => {
            Object.keys(distObj).forEach((dist, k) => {
              distObj[dist].forEach((pinObj) => {
                Object.keys(pinObj).forEach((pin) => {
                  pinObj[pin].forEach((village) => {
                    locData.push({
                      state: state,
                      dist: dist,
                      pin: pin,
                      village: village,
                    });
                  });
                });
              });
            });
          });
        });
      });
      let stateDataObj = [...new Set(locData.map((item) => item.state))].map(
        (item) => ({ label: item, value: item })
      );
      setLocations(locData);
      setStateData(stateDataObj);
    } catch (err) {
      console.log(err);
    }
  }

  const handleStateChange = (state) => {
  
      let data = locations.filter((l) => state.includes(l.state));
      let distData = [...new Set(data.map((item) => item.dist))].map(
        (item) => ({
          label: item,
          value: item,
        })
      );
      setState(state);
      setDistData(distData);

  };
  const handleDistChange = (dist) => {
   if (activeState) {
    let data = locations.filter((l) => activeState.includes(l.state))
        .filter((d) => dist.includes(d.dist));
      let villageData = [...new Set(data.map((item) => item.village))].map(
        (item) => ({ label: item, value: item })
      );
      setDist(dist);
      setVillageData(villageData);
   }
  };

  const handleVillageChange = (village) => {
    setVillage(village);
  };

  const handleApprover = (checked) => {
    setShowLevels(checked);
  };
  console.log("state ---- ", activeState);
  return (
    <Modal size="md" open={props.open} onClose={handleClose}>
      <Modal.Header>
        <Modal.Title>
          <strong className="text-danger">
            Assign Role to {props.user.name}
          </strong>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="model-body">
          <div className="profile">
            <div className="name col-4">
              <div className="text-secondary">Name</div>
              <div>{props.user.name}</div>
            </div>
            <div className="name col-4">
              <div className="text-secondary">Mobile No</div>
              <div>{props.user.phone_number}</div>
            </div>
            <div className="name col-4">
              <div className="text-secondary">Email ID</div>
              <div>{props.user.user_id}</div>
            </div>
          </div>

          <div className="profile">
            <div className="name col-6">
              <div className="text-dark">
                <strong>Select Primary Role</strong>
              </div>
              <div>
                <SelectPicker
                  data={roleData}
                  value={activeRole}
                  placeholder="Select Status"
                  onChange={handleChangeRoles}
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          </div>

          <div className="profile">
            <div className="name">
              <div className="text-dark">
                <strong>Select Additional Role</strong>
              </div>
              <div>
                <CheckboxGroup
                  name="checkboxList"
                  value={activeAdditionalRole}
                  inline
                  onChange={handleChangeAdditionalRoles}
                >
                  {additionalRoleData.map(
                    (item) =>
                      !excludedIds.includes(item.id) && (
                        <Checkbox className={"role_" + item.id} value={item.id}>
                          {item.role}
                        </Checkbox>
                      )
                  )}
                </CheckboxGroup>
                <Checkbox
                  checked={showLevels}
                  className={"role_" + 6}
                  onChange={() => handleApprover(!showLevels)}
                >
                  Approver
                </Checkbox>
              </div>
            </div>
          </div>

          {showLevels ? (
            <div className="profile">
              <div className="name">
                <div className="text-dark">
                  <strong>Select Level </strong>
                </div>
                <div>
                  <RadioGroup
                    inline
                    name="radio-name"
                    value={activeLevel}
                    onChange={handleChangeLevel}
                  >
                    {Levels.map((item) => (
                      <Radio value={item.id}>{item.level}</Radio>
                    ))}
                  </RadioGroup>
                </div>
              </div>
            </div>
          ) : null}

          {(activeLevel < 4 ||
            (activeAdditionalRole ?? []).includes(2) ||
            activeRole == 2) && (
            <div className="profile">
              <div className="name">
                <div className="text-dark">
                  <strong>Select Location (for level)</strong>
                </div>
                <div className="row">
                  {(activeLevel == 1 ||
                    activeLevel == 2 ||
                    activeLevel == 3 ||
                    (activeAdditionalRole ?? []).includes(2) ||
                    activeRole == 2) && (
                    <div className="col-4">
                      <CheckPicker
                        data={stateData}
                        value={activeState}
                        label="State"
                        onChange={handleStateChange}
                        style={{ width: 224 }}
                      />
                    </div>
                  )}
                  {(activeLevel == 2 ||
                    activeLevel == 1 ||
                    (activeAdditionalRole ?? []).includes(2) ||
                    activeRole == 2) && (
                    <div className="col-4">
                      <CheckPicker
                        data={distData}
                        value={activeDist}
                        label="District"
                        onChange={handleDistChange}
                        style={{ width: 224 }}
                      />
                    </div>
                  )}
                  {(activeLevel == 1 ||
                    (activeAdditionalRole ?? []).includes(2) ||
                    activeRole == 2) && (
                    <div className="col-4">
                      <CheckPicker
                        data={villageData}
                        value={activeVillage}
                        label="Block"
                        onChange={handleVillageChange}
                        style={{ width: 224 }}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => handleConfirm()} className="btn btn-default">
          Confirm
        </Button>
        <Button onClick={handleClose} appearance="subtle">
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
